export default {
  LABEL: 'label'
};


// WEBPACK FOOTER //
// ./src/components/ItemTypes.js